if (!customElements.get('wim-carousel')) {
    customElements.define('wim-carousel', class WimCarousel extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.track = this.querySelector('.wim-carousel__track');
            this.prevBtn = this.querySelector('.wim-prev-btn');
            this.nextBtn = this.querySelector('.wim-next-btn');

            if (this.prevBtn) {
                this.prevBtn.addEventListener('click', () => this.scroll('left'));
            }
            if (this.nextBtn) {
                this.nextBtn.addEventListener('click', () => this.scroll('right'));
            }

            // Optional: Check scroll position to disable buttons
            if (this.track) {
                this.track.addEventListener('scroll', () => this.updateButtons());
                // Initial check
                requestAnimationFrame(() => this.updateButtons());
            }

            // Autoplay setup
            this.autoplay = this.dataset.autoplay === 'true';
            this.autoplayIntervalTime = parseInt(this.dataset.autoplayInterval) || 5000;
            this.autoplayTimer = null;

            if (this.autoplay && this.track) {
                this.startAutoplay();

                // Pause autoplay on hover or interaction
                this.addEventListener('mouseenter', () => this.stopAutoplay());
                this.addEventListener('mouseleave', () => this.startAutoplay());
                this.track.addEventListener('touchstart', () => this.stopAutoplay(), { passive: true });
                this.track.addEventListener('touchend', () => this.startAutoplay());
            }
        }

        disconnectedCallback() {
            this.stopAutoplay();
        }

        startAutoplay() {
            if (!this.autoplayTimer) {
                this.autoplayTimer = setInterval(() => {
                    this.scroll('right', true);
                }, this.autoplayIntervalTime);
            }
        }

        stopAutoplay() {
            if (this.autoplayTimer) {
                clearInterval(this.autoplayTimer);
                this.autoplayTimer = null;
            }
        }

        scroll(direction, isAutoplay = false) {
            if (!this.track) return;

            // Get width of one slide + gap
            const slide = this.track.querySelector('.wim-carousel__slide');
            if (!slide) return;

            const slideWidth = slide.offsetWidth;
            const style = window.getComputedStyle(this.track);
            const gap = parseInt(style.getPropertyValue('gap') || style.getPropertyValue('grid-column-gap') || 0);
            const scrollAmount = slideWidth + gap;

            const maxScroll = this.track.scrollWidth - this.track.clientWidth;
            const tolerance = 10;

            if (direction === 'left') {
                if (isAutoplay && this.track.scrollLeft <= tolerance) {
                    // Go to end if at start during autoplay
                    this.track.scrollTo({ left: maxScroll, behavior: 'smooth' });
                } else {
                    this.track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                }
            } else {
                if (isAutoplay && this.track.scrollLeft >= maxScroll - tolerance) {
                    // Loop back to start if at end during autoplay
                    this.track.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    this.track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                }
            }
        }

        updateButtons() {
            if (!this.prevBtn || !this.nextBtn || !this.track) return;

            const tolerance = 10; // px
            const scrollLeft = this.track.scrollLeft;
            const maxScroll = this.track.scrollWidth - this.track.clientWidth;

            // Prev Button
            if (scrollLeft <= tolerance) {
                this.prevBtn.setAttribute('disabled', 'true');
                this.prevBtn.style.opacity = '0.5';
                this.prevBtn.style.pointerEvents = 'none';
            } else {
                this.prevBtn.removeAttribute('disabled');
                this.prevBtn.style.opacity = '1';
                this.prevBtn.style.pointerEvents = 'auto';
            }

            // Next Button
            if (scrollLeft >= maxScroll - tolerance) {
                this.nextBtn.setAttribute('disabled', 'true');
                this.nextBtn.style.opacity = '0.5';
                this.nextBtn.style.pointerEvents = 'none';
            } else {
                this.nextBtn.removeAttribute('disabled');
                this.nextBtn.style.opacity = '1';
                this.nextBtn.style.pointerEvents = 'auto';
            }
        }
    });
}
